





















import { Component, Vue, namespace } from 'nuxt-property-decorator'
import LazyHydrate from 'vue-lazy-hydration'
import { ILinkItem } from '~/assets/interfaces/navigation'

const siteStore = namespace('site')

@Component({
  components: {
    LazyHydrate,
    ComponentHeaderTopLineType1: () =>
      import('~/components/header/header-top-line-type-1.vue'),
    ComponentHeaderMainLineType1: () =>
      import('~/components/header/header-main-line-type-1.vue'),
    ComponentHeaderMenu: () => import('~/components/header/header-menu.vue'),
  },
})
export default class ComponentHeaderVariant5 extends Vue {
  @siteStore.Mutation('setFixedHeaderHeight') private setFixedHeaderHeight!: (
    height: number
  ) => void

  @siteStore.State('headerMenu') private headerMenu!: ILinkItem[]

  private get hasHeaderMenu() {
    return !!(this.headerMenu && this.headerMenu.length)
  }

  private isFixed = false
  private headerHeight = 142

  private makeFixed() {
    this.isFixed = window.scrollY > this.headerHeight
  }

  private addListener() {
    window.addEventListener('scroll', this.makeFixed)
  }

  private removeListener() {
    window.removeEventListener('scroll', this.makeFixed)
  }

  private mounted() {
    this.$emit('loaded')

    if (process.client) {
      const header = this.$refs.header as HTMLElement
      this.headerHeight = header.clientHeight

      this.setFixedHeaderHeight(76)

      this.makeFixed()
      this.addListener()
    }
  }

  private beforeDestroy() {
    if (process.client) {
      this.removeListener()
    }
  }
}
